import { render, staticRenderFns } from "./fzdy_detail.vue?vue&type=template&id=8e6e8444&"
import script from "./fzdy_detail.vue?vue&type=script&lang=js&"
export * from "./fzdy_detail.vue?vue&type=script&lang=js&"
import style0 from "./fzdy_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports